<div class="checkDialogue">
    <div class="textSec d-flex flex-column">
      <span class="topHead">Are you sure you want to mark this datum as checked?</span>
      <span class="tailEnd mt-4"
        >This is a critical action, please recheck before proceeding!</span
      >
    </div>
    <div class="actionSec mt-4">
      <div class="actionBtn d-flex justify-content-between">
        <button class="continue dp-primary-btn cursor-pointer" (click)="checkDatum()">
          <!-- <div class="cross"></div> -->
          <span>Yes, Continue</span>
        </button>
        <button
          type="button"
          class="dp-secondary-btn cancel"
          mat-button
          mat-dialog-close
        >
          <span> No, cancel </span>
        </button>
      </div>
    </div>
  </div>
